import { render, staticRenderFns } from "./AddOrEditOpportunities.vue?vue&type=template&id=36a9969e&"
import script from "./AddOrEditOpportunities.vue?vue&type=script&lang=js&"
export * from "./AddOrEditOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditOpportunities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports